module.exports = __webpack_public_path__ + "pnskfsquadron/img/ja-slider-2.jpg?036b17d0";